
import * as Icon from 'react-feather'
import {confirmAlert} from 'react-confirm-alert'
import 'react-confirm-alert/src/react-confirm-alert.css'
import {default_confirm_message, default_confirm_title} from "../config/defaults";

const UseConfirm = (props) => {
    const {title, description, onConfirm, onCancel} = props


    const handleConfirmation = () => {
        if(typeof onConfirm === "function"){
            onConfirm()
        }
    }


    const handleCancelation = () => {
        if(typeof onCancel === "function"){
            onCancel()
        }
    }


    confirmAlert({
        title: title,
        message: description,
        customUI: ({ onClose }) => {
            return (
                <div className='confirmation-ui'>
                    <h1>{title ? title : default_confirm_title}</h1>
                    <p>{description ? description : default_confirm_message}</p>
                    <button className="btn btn-rect btn-primary" onClick={() => {handleConfirmation(); onClose(); }}>
                        <Icon.Check/> Yes
                    </button>
                    <button className="btn btn-rect btn-primary" onClick={()=>{handleCancelation(); onClose(); }}>
                        <Icon.X /> No
                    </button>
                </div>
            )
        }
    });


}

export default UseConfirm;